import { render } from "./NotUsableChoicesModal.vue?vue&type=template&id=22c6e982&scoped=true"
import script from "./NotUsableChoicesModal.vue?vue&type=script&lang=js"
export * from "./NotUsableChoicesModal.vue?vue&type=script&lang=js"

import "./NotUsableChoicesModal.vue?vue&type=style&index=0&id=22c6e982&scoped=true&lang=css"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c6e982"]])

export default __exports__